var _style, _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 236.08 178.56",
    style: {
      enableBackground: "new 0 0 236.08 178.56"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#ff6300;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M212.4,84.91"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "39.37,59.06 89.64,8.79 89.64,59.06 64.11,84.59  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "196.22,59.06 145.95,8.79 145.95,59.06 171.48,84.59  "
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 117.79,
    cy: 82.43,
    r: 13.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 103.77,
    cy: 106.5,
    r: 13.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 132.01,
    cy: 106.5,
    r: 13.5
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "32.46,110.18 64.13,141.85 74.59,131.39 83.06,139.86 53.15,169.77 12.35,128.97 31.78,109.53  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "203.62,109.62 171.95,141.29 161.49,130.82 153.03,139.29 182.94,169.2 223.74,128.4 204.3,108.96  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M198.59,61.74l-26.46,26.46l-54.21-53.9L64.04,88.13L37.65,61.74L13.18,86.21l51.47,51.47l13.54-13.54 l11.22-11.22c-2.14-4.28-3.34-9.1-3.34-14.2c0-17.59,14.26-31.85,31.85-31.85s31.85,14.26,31.85,31.85 c0,5.08-1.2,9.88-3.32,14.14l0.02-0.03l11.56,11.31l13.54,13.54l51.47-51.47L198.59,61.74z"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M468.49,84.91"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "295.45,59.06 345.72,8.79 345.72,59.06 320.19,84.59  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "452.31,59.06 402.04,8.79 402.04,59.06 427.57,84.59  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "288.55,110.18 320.22,141.85 330.68,131.39 339.14,139.86 309.23,169.77 268.43,128.97  287.87,109.53  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "459.71,109.62 428.04,141.29 417.58,130.82 409.11,139.29 439.02,169.2 479.82,128.4 460.38,108.96  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M454.67,61.74l-26.46,26.46l-54.21-53.9l-53.88,53.83l-26.39-26.39l-24.47,24.47l51.47,51.47l13.54-13.54 l11.22-11.22c-2.14-4.28-3.34-9.1-3.34-14.2c0-17.59,14.26-31.85,31.85-31.85s31.85,14.26,31.85,31.85 c0,5.08-1.2,9.88-3.32,14.14l0.02-0.03l11.56,11.31l13.54,13.54l51.47-51.47L454.67,61.74z"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo2);
export default __webpack_public_path__ + "static/media/logo2.16ecc794ad5b197bd782ad90f5f1eca8.svg";
export { ForwardRef as ReactComponent };